import { ENTRY_LINK as CBR_DASHBOARD_ENTRY_LINK } from 'cbr-dashboard';
import { ENTRY_LINK as CQM_DASHBOARD_ENTRY_LINK } from 'cqm-dashboard';
import { ENTRY_LINK as EHIEXPORT_DASHBOARD_ENTRY_LINK } from 'ehi-export-dashboard';
import { hasUserRoles, isClinician } from 'user';

const displayLink = (user, __, featureToggles) => {
  return (
    hasUserRoles(user, ['cbrbeta']) ||
    hasUserRoles(user, ['admin']) ||
    hasUserRoles(user, ['security-admin']) ||
    isClinician(user)
  );
};

export const ENTRY_LINK = {
  path: '/report-dashboard',
  text: 'Reports',
  icon: 'analytics',
  permission: 'create',
  children: [
    CBR_DASHBOARD_ENTRY_LINK,
    EHIEXPORT_DASHBOARD_ENTRY_LINK,
    CQM_DASHBOARD_ENTRY_LINK,
  ],
  displayLink: displayLink,
};
